import React, { useState, useRef } from 'react';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import map_marker from '/images/icons/map-marker.svg';
import { translate } from '../Services/translation';
 
export function GoogleMapContainer(props) {
    
    const { google, markers} = props;
    const [filteredMarkers, setFilteredMarkers] = useState(markers);
    const [centeredMarker, setCenteredMarker] = useState(null);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const markerRefs = useRef([]);
    const [query, setQuery] = useState("");

    const mapStyle = [
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 65
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": "50"
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "30"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "40"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "hue": "#ffff00"
                },
                {
                    "lightness": -25
                },
                {
                    "saturation": -97
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "lightness": -25
                },
                {
                    "saturation": -100
                }
            ]
        }
    ];

    const onMarkerClick = (props, marker, e) => {
        setSelectedMarker(marker);
        setCenteredMarker(props.position);
    }
    const markerSelected = (event, marker) => {
        setCenteredMarker({
            lat: parseFloat(marker.Latitude),
            lng: parseFloat(marker.Longitude)
        });
        let clickedMarkerRef = markerRefs.current.filter((x) => !!x && x.props.position.lat == marker.Latitude && x.props.position.lng == marker.Longitude);
        if(clickedMarkerRef && clickedMarkerRef.length > 0){
            onMarkerClick(clickedMarkerRef[0].props, clickedMarkerRef[0].marker);
        }
    }
    const filterMarkers = (value) => {
        setQuery(value);
        if(value !== ''){
            value = value.toLowerCase();
            var result = markers.filter((object) => (object.Title.toString().toLowerCase().includes(value)) || (object.Address.Value.toString().toLowerCase().includes(value)));
            setFilteredMarkers(result);
        }else{
            setFilteredMarkers(markers);
        }
    }

    const _mapLoaded = (mapProps, map) => {
        map.setOptions({
           styles: mapStyle
        })
     }

    const containerStyle = {
        position: 'relative',  
        width: '100%',
        height: '100%'
    }

    const _initMap = (props, map) => {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < filteredMarkers.length; i++) {
            var x = { lat: parseFloat(filteredMarkers[i].Latitude), lng: parseFloat(filteredMarkers[i].Longitude) }
            bounds.extend(x);
        }
        _mapLoaded(props, map);
        map.fitBounds(bounds);
        map.panToBounds(bounds);
    }
   

    return(
        <div className="row google-map__wrapper">
            <div className="columns small-12 large-3 google-map__list">
                <div className="google-map__search">
                    <input autoComplete="do-not-autocomplete" placeholder={translate('google.maps.placeholder')} value={query} onChange={(e) => filterMarkers(e.target.value)}/>
                    <div className="google-map__search-btn">
                        <i className="fal fa-search"></i>
                    </div>
                </div>
                <ul>
                    {filteredMarkers.map((marker, i) =>
                        <div className="google-map__list-item" key={`${marker.Title}-${i}`} onClick={(e) => markerSelected(e, marker)}>
                            <li >
                                <h4>{marker.Title}</h4>
                                <div dangerouslySetInnerHTML={{__html: marker.Address.Value}}></div>
                            </li>
                        </div>
                    )}
                </ul>
            </div>
            <div className="columns small-12 large-9 google-map__map">
                <Map google={google}
                    zoom={5}
                    containerStyle={containerStyle}
                    initialCenter={{
                        lat: 58.977157,
                        lng: 14.038979
                    }}
                    center={centeredMarker}
                    onReady={(mapProps, map) => _initMap(mapProps, map)}>

                    {filteredMarkers.map((marker, i) => 
                        <Marker key={`${marker.Title}-${i}`}
                        ref={marker => markerRefs.current[i] = marker}
                        name={marker.Title}
                        title={marker.Title}
                        description={marker.Address.Value}
                        position={{lat: parseFloat(marker.Latitude), lng: parseFloat(marker.Longitude)}}
                        onClick={onMarkerClick}
                        icon={{
                            url: map_marker,
                            anchor: new google.maps.Point(24,48),
                            scaledSize: new google.maps.Size(48,48)
                        }}
                        />
                    )}
                    <InfoWindow
                        marker={selectedMarker}
                        visible={selectedMarker !== null}
                        >
                            {selectedMarker &&  
                            <div>
                                <h4>{selectedMarker.name}</h4>
                                <div dangerouslySetInnerHTML={{__html: selectedMarker.description}}></div>
                            </div>
                            }
                    </InfoWindow>             
                </Map>
            </div>
        </div>
    );

}
 
export default GoogleApiWrapper((props) => ({
    language: props.language,
    apiKey: 'AIzaSyCY1xGBTvywPkjrWhkQULhoKq2CKP48dWw'
}))(GoogleMapContainer)